import React from "react";
import { t } from "../../../../utils/i18n";
import { formatCurrency } from "../Helper";

const PaymentFormFields = ({
  formData,
  handleInputChange,
  handleBlur,
  errors,
  currencies,
  exchangeRates,
  isLoadingRates,
  calculateUsdAmount,
}) => {
  const sortedCurrencies = Object.entries(currencies).sort((a, b) =>
    a[0].localeCompare(b[0])
  );

  return (
    <>
      {/* Amount Input */}
      <div className="form-group">
        <label htmlFor="amount">{t("store_integrations.widget.amount_req")}</label>
        <div className="currency-input-wrapper">
          <input
            type="text"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder="0.00"
            required
            className={`form-input ${errors.amount ? "error" : ""}`}
            aria-describedby={errors.amount ? "amount-error" : undefined}
          />
          <span className="currency-code">{formData.currency}</span>
        </div>
        {errors.amount && (
          <div className="error-message" id="amount-error">
            {errors.amount}
          </div>
        )}
        {formData.amount && !isNaN(parseFloat(formData.amount)) && (
          <div className="amount-display">
            {formatCurrency(parseFloat(formData.amount), formData.currency)}
          </div>
        )}
      </div>

      {/* Currency Select */}
      <div className="form-group">
        <label htmlFor="currency">{t("store_integrations.widget.currency_req")}</label>
        <select
          id="currency"
          name="currency"
          value={formData.currency}
          onChange={handleInputChange}
          onBlur={handleBlur}
          className={`form-select ${errors.currency ? "error" : ""}`}
          required
          aria-describedby={errors.currency ? "currency-error" : undefined}
        >
          {sortedCurrencies.map(([code, currency]) => (
            <option key={code} value={code}>
              {code} ({currency.name})
            </option>
          ))}
        </select>
        {errors.currency && (
          <div className="error-message" id="currency-error">
            {errors.currency}
          </div>
        )}
      </div>

      {/* Currency Conversion Info */}
      {formData.currency !== "USD" &&
        formData.amount &&
        !isNaN(parseFloat(formData.amount)) && (
          <div className="currency-conversion-info">
            <p>
              {t("store_integrations.widget.estimated_usd")}{" "}
              {exchangeRates &&
              Object.keys(exchangeRates).length > 0 &&
              exchangeRates[formData.currency]
                ? formatCurrency(
                    calculateUsdAmount(
                      parseFloat(formData.amount),
                      formData.currency,
                      exchangeRates
                    ),
                    "USD"
                  )
                : t("store_integrations.widget.rate_unavailable")}
              {isLoadingRates && (
                <span className="loading-indicator"> {t("store_integrations.widget.loading_rates")}</span>
              )}
            </p>
          </div>
        )}
    </>
  );
};

export default PaymentFormFields;
